import { OptionFormDtoUpperCase } from './../models/dialog-dto/option-form.dto';
import { OptionFormDto } from 'src/app/models/dialog-dto/option-form.dto';
import { LicenceDashboard } from 'src/app/modules/dashboard/models/licence-dashboard';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogAddClientComponent } from '../components/dialog-add-client/dialog-add-client.component';
import { DialogAddCustomerComponent } from '../components/dialog-add-customer/dialog-add-customer.component';
import { DialogAddLicenceComponent } from '../components/dialog-add-licence/dialog-add-licence.component';
import { RestService } from './rest.service';
import { AddClientDto } from '../models/dialog-dto/add-client.dto';
import { Company } from '../models/company';
import {
  CompanyItemDto,
  CompanyListItemDto,
} from '../models/dialog-dto/company-list-item.dto';
import { DialogDeleteClientComponent } from '../components/dialog-delete-client/dialog-delete-client.component';
import { AddCustomerDto } from '../models/dialog-dto/add-customer.dto';
import { DialogDeleteCustomerComponent } from '../components/dialog-delete-customer/dialog-delete-customer.component';
import {
  CustomerItemDto,
  CustomerListItemDto,
} from '../models/dialog-dto/customer-list-item.dto';
import { CompanySelectDto } from '../models/dialog-dto/company-select.dto';
import { DataService } from './data.service';
import { DeleteLicenceDto, LicenceDto, LicenceDtoUpper } from '../models/licenceDto';
import { DialogDeleteLicenceComponent } from '../components/dialog-delete-licence/dialog-delete-licence.component';
import { AddLicenceDto } from '../models/dialog-dto/add-licence.dto';
import { DialogViewOptionsComponent } from '../components/dialog-view-options/dialog-view-options.component';
import { DialogViewSmaComponent } from '../components/dialog-view-sma/dialog-view-sma.component';
import { DialogMergeLicenceComponent } from '../components/dialog-merge-licence/dialog-merge-licence.component';
import { DialogSetOptionsComponent } from '../components/dialog-set-options/dialog-set-options.component';
import { DialogEditPasswordComponent } from '../components/dialog-edit-password/dialog-edit-password.component';
import { DialogOfflineDemoDateComponent } from '../components/dialog-offline-demo-date/dialog-offline-demo-date.component';
import { DialogConfirmComponent, DialogConfirmData } from '../components/dialog-confirm/dialog-confirm.component';
import { DialogAddOptionsOverviewComponent } from '../components/dialog-add-options-overview/dialog-add-options-overview.component';
import { LicenceFormDto } from '../models/dialog-dto/licence-form.dto';
import { OverviewClientDto } from '../modules/overview/models/overview-client-dto';
import { OverviewCustomerDto } from '../modules/overview/models/overview-customer-dto';
import { DialogExportCsvComponent } from '../components/dialog-export-csv/dialog-export-csv.component';
import { TranslateService } from '@ngx-translate/core';
import { SuccessData } from '../modules/shared/components/success/success.component';
import { DialogDeleteUserComponent } from '../components/dialog-delete-user/dialog-delete-user.component';
import { DialogAddUserComponent } from '../components/dialog-add-user/dialog-add-user.component';
import { DialogTagScopeComponent, DialogTagScopeData } from '../components/dialog-tag-scope/dialog-tag-scope.component';
import { Tag } from '../models/user';
import {OptionTypeUpper} from "../models/option-type";
import {
  DialogEditOptionDescriptionComponent
} from "../components/dialog-edit-option-description/dialog-edit-option-description.component";
import { DialogDatabaseBackupComponent } from '../components/dialog-database-backup/dialog-database-backup.component';
import { DialogMfaSetupComponent } from '../components/dialog-mfa-setup/dialog-mfa-setup.component';
import { DialogMfaCodeComponent } from '../components/dialog-mfa-code/dialog-mfa-code.component';
import { DialogAssignVrsComponent, DialogAssignVrsData } from '../components/dialog-assign-vrs/dialog-assign-vrs.component';
import { DialogEasybillImportComponent } from '../components/dialog-easybill-import/dialog-easybill-import.component';
import { EasybillSyncType } from '../models/dialog-dto/easybill-sync.dto';

@Injectable({
  providedIn: 'root',
})
export class DialogService {

  constructor(
    private dialog: MatDialog,
    private _restService: RestService,
    private dataService: DataService,
    private translate: TranslateService
  ) {}

  dialogAfterClose(dialog: MatDialogRef<any, any> | undefined, messageEn: string, messageDe: string, successData: SuccessData, change: boolean, result: boolean): [SuccessData, boolean]{
      if (result) {
        if (this.translate.store.currentLang == 'en') {
          successData = {
            element_id: 'dataMsg',
            element_msg: messageEn,
          };
        } else {
          successData = {
            element_id: 'dataMsg',
            element_msg: messageDe,
          };
        }
        change = !change;
      }
    return [successData, change]
  }

  /**
   *
   */
  openAddClient() {
    return this.dialog.open(DialogAddClientComponent, {width: "80rem"});
  }

  openEditPassword(guid: string) {
    return this.dialog.open(DialogEditPasswordComponent, {data: {guid: guid}, width: "80rem"})
  }

  openOfflineDemoDate() {
    return this.dialog.open(DialogOfflineDemoDateComponent, {width: "30rem"})
  }

  openConfirm(data: DialogConfirmData) {
    return this.dialog.open(DialogConfirmComponent, {data, width: "32rem"})
  }

  openEditDescription(optionType: OptionTypeUpper) {
    return this.dialog.open(DialogEditOptionDescriptionComponent, {data: optionType, width: "80rem"})
  }

  /**
   *
   * @param guid
   */
  openEditClient(guid: string) {
    return this.dialog.open(DialogAddClientComponent, {
      data: { guid: guid }, width: "80rem"
    });
  }


  /**
   *
   * @param guid
   * @returns
   */
  getEditClientData(id: number | string) {
    return this._restService.get<AddClientDto>(`/clients/${id}`);
  }

  /**
   *
   * @param guid
   * @returns
   */
  getEditClientDataGuid(id: string) {
    return this._restService.get<AddClientDto>(`/clients/${id}`);
  }

  /**
   *
   * @returns
   */
  getClientsList() {
    return this._restService.get<CompanyListItemDto[]>('/clients');
  }

  getMyClientsList() {
    return this._restService.get<CompanyListItemDto[]>('/clients/my');
  }

  getCustomersList() {
    return this._restService.get<CustomerListItemDto[]>('/customers');
  }

  getLicence(id: string | number) {
    return this._restService.get<LicenceDtoUpper>(`/licences/${id}`)
  }

  getLicenceListByCustomer(id: string | number) {
    return this._restService.get<LicenceDtoUpper[]>(`/licences/byCustomer/${id}`)
  }

  getSelectedClient(id: string | number) {
    return this._restService.get<CompanyItemDto>(`/clients/${id}`);
  }

  getClientByCompanyId(id: number | string) {
    return this._restService.get<CompanyItemDto>(`/clients/company/${id}`)
  }

  openDeleteClient(guid: string) {
    return this.dialog.open(DialogDeleteClientComponent, {
      data: { guid: guid }
    });
  }

  //client is the id of the client which the customer belongs to
  openAddCustomer(client?: string | number) {
    return this.dialog.open(DialogAddCustomerComponent, {data: {client: client}, width: "80rem" });
  }

  openEditCustomer(guid: string) {
    return this.dialog.open(DialogAddCustomerComponent, {
      data: { guid: guid }, width: "80rem"
    });
  }

  /**
   *
   * @param guid
   * @returns
   */
  getEditCustomerData(guid: string) {
    return this._restService.get<AddCustomerDto>(`/customers/${guid}`);
  }

  getEditLicenceData(guid: string) {
    return this._restService.get<DeleteLicenceDto>(`/licences/${guid}`);
  }

  /**
   *
   * @returns
   */
  getCustomerList(clientId: number) {
    return this._restService.get<CustomerListItemDto[]>(
      `/customers/byClient/${clientId}`
    );
  }

  getSelectedCustomer(guid: string | number) {
    return this._restService.get<CustomerItemDto>(`/customers/${guid}`);
  }

  getSelectedCustomerByCustomerId(guid: string | number) {
    return this._restService.get<CustomerItemDto>(`/customers/customerid/${guid}`);
  }

  openDeleteCustomer(guid: string) {
    return this.dialog.open(DialogDeleteCustomerComponent, {
      data: { guid: guid },
    });
  }

  openEditUser(guid: string) {
    return this.dialog.open(DialogAddUserComponent, {data: {guid: guid}, width: "80rem"})
  }

  openTagScope(tag: Tag) {
    return this.dialog.open(DialogTagScopeComponent, {
      data: { tagId: tag.ID, tagGuid: tag.GUID, tagName: tag.Name } as DialogTagScopeData,
      width: '60rem',
    });
  }

  openAddUser() {
    return this.dialog.open(DialogAddUserComponent, {width: "80rem"})
  }

  openDeleteUser(guid: string) {
    return this.dialog.open(DialogDeleteUserComponent, {
      data: {guid: guid}, width: "80rem"
    })
  }

  openAddLicence(guid?: string) {
    if (guid) {
      return this.dialog.open(DialogAddLicenceComponent, {
        data: { licenceData: {customer_id: guid, vrs: "", project: ""}as unknown as LicenceDto, licenceOptionData: [] as OptionFormDtoUpperCase[]},  width: "80rem"
      });
    } else {
      return this.dialog.open(DialogAddLicenceComponent, {
        width: "80rem"
      });
    }
  }

  openEditLicence(guid: string): Observable<MatDialogRef<DialogAddLicenceComponent>> {
    let licenceOptionData: OptionFormDtoUpperCase[] = [];
    this.dataService.getOptionsByLicence(guid).subscribe((val) => {
      licenceOptionData.push(...val);
    });

    return this.dataService.refreshLicenceById(guid).pipe(
      map(licenceData => this.dialog.open(DialogAddLicenceComponent, {
        data: { licenceData, licenceOptionData },
        width: '80rem'
      }))
    );
  }

  openAddOptionsOverview() {
    return this.dialog.open(DialogAddOptionsOverviewComponent, {
      data: {}, width: "80rem"
    })
  }

  openDeleteLicence(guid: string) {
    return this.dialog.open(DialogDeleteLicenceComponent, {
      data: { guid: guid }
    });
  }

  openViewOptions(guid: string, client: OverviewClientDto, customer: OverviewCustomerDto) {
    return this.dialog.open(DialogViewOptionsComponent, {
      data: {guid: guid, client: client, customer: customer}, width: "80rem"
    })
  }

  openExportCSV(licenceGuid?: string, customerGuid?: number, clientGuid?: number) {
    this.dialog.open(DialogExportCsvComponent, {
      data: {licenceGuid: licenceGuid, customerGuid: customerGuid, clientGuid: clientGuid}, width: "80rem"
    })
  }

  openSetOptions(guid: string){
    return this.dialog.open(DialogSetOptionsComponent, {
      data: {guid: guid}, width: "80rem"
    })
  }

  openViewSma(licenceGuid: string, licenceName: string) {
    return this.dialog.open(DialogViewSmaComponent, {
      data: { licenceGuid, licenceName }, width: '60rem'
    });
  }

  openMergeLicence(licenceA: any, licenceB: any) {
    return this.dialog.open(DialogMergeLicenceComponent, {
      data: { licenceA, licenceB }, width: '40rem'
    });
  }

  openDatabaseBackup() {
    return this.dialog.open(DialogDatabaseBackupComponent, { width: '50rem' });
  }

  /** Enable MFA for the current user (QR enrollment). */
  openMfaSetup() {
    return this.dialog.open(DialogMfaSetupComponent, { width: '32rem' });
  }

  /** Ask for a current TOTP code to disable MFA or regenerate backup codes. */
  openMfaCode(action: 'disable' | 'regenerate') {
    return this.dialog.open(DialogMfaCodeComponent, {
      data: { action }, width: '32rem',
    });
  }

  openAssignVrs(data: DialogAssignVrsData) {
    return this.dialog.open(DialogAssignVrsComponent, { data, width: '40rem' });
  }

  openEasybillImport(syncType: EasybillSyncType) {
    return this.dialog.open(DialogEasybillImportComponent, { data: { syncType }, width: '60rem' });
  }
}
